import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf';

import { updateEventStatus } from '../api/events';

import Modal from '../components/Shell/Modal';

import useAsync from '../hooks/useAsync';
import useModal from '../hooks/useModal';
import usePrevious from '../hooks/usePrevious';
import { classNames } from '../components/helpers/functions';
import {
	TemplateBoolean,
	TemplateCheckbox,
	TemplateDate,
	TemplateFile,
} from '../components/Attributes/Attributes_old';
import Button from '../components/Button';
import Banner from '../components/Banner';
import { CheckBadgeIcon, SparklesIcon } from '@heroicons/react/24/outline';
import { completeTask } from '../api/services';

const MODAL_NAME = 'taskCompletedModal';

export default () => {
	const { open: options, setClose: onCloseModal } = useModal(MODAL_NAME);
	const [form, setForm] = useState({});
	const [updatedForm, setUpdateForm] = useState({});
	const [scheduleAgain, setScheduleAgain] = useState(null);
	const [documentUploadForm, setDocumentUploadForm] = useState({});

	const { execute: onEventStatusUpdate } = useAsync(updateEventStatus, {
		immediate: false,
	});

	const { execute: onCompleteTask, status: completingTask } = useAsync(
		completeTask,
		{
			immediate: false,
		}
	);

	useEffect(() => {
		if (options?.defaultForm) {
			setForm(options.defaultForm);
		}
	}, [options?.defaultForm]);

	const prevOptions = usePrevious(options);
	useEffect(() => {
		if (!options && prevOptions) {
			setForm({});
			setUpdateForm({});
		}
	}, [options]);

	const handleClose = () => {
		onCloseModal();

		if (typeof options?.onClose === 'function') {
			options?.onClose(response);
		}

		setScheduleAgain(null);
		setForm({});
		setUpdateForm({});
		setDocumentUploadForm({});
	};

	const currentForm = { ...form, ...updatedForm };

	return (
		<Modal
			name={MODAL_NAME}
			key={MODAL_NAME}
			title="Completing task"
			onClose={() => handleClose()}
		>
			<div className="space-y-3">
				{options?.eventId && (
					<Banner size="xs">
						{`Completing task due`}{' '}
						<span className="font-semibold">{`${moment(
							options?.service?.nextEvent?.scheduledDate ||
								options?.service?.nextEvent?.estimatedDate
						).format('MMMM Do, YYYY')}`}</span>
					</Banner>
				)}
				<TemplateDate
					name="Date Completed"
					onChange={(index, completedDate) =>
						setUpdateForm({ ...updatedForm, completedDate })
					}
					value={currentForm?.completedDate}
					maxDate={moment().toDate()}
				/>

				{documentUploadForm?.length ? (
					<div>
						<div className="flex justify-center items-center py-10 text-gray-500">
							<CheckBadgeIcon className="w-10 h-10 text-green-400 mr-3" /> PDF
							Attached Successfully
						</div>
					</div>
				) : (
					<>
						<TemplateFile
							name="Attach PDF"
							onChange={(index, files) => {
								setDocumentUploadForm(files);
							}}
						/>
					</>
				)}

				{!options?.service?.occurrences ||
				options?.service?.occurrences === 'none' ? (
					<div>
						<div className="mb-4 text-indigo-700">
							<Banner size="xs">
								This task does not have recurring set. Do you want to schedule
								this task again?
								<div className="flex items-center justify-center mt-2">
									<div
										onClick={() => setScheduleAgain(true)}
										className={classNames(
											'p-4 m-2 cursor-pointer border border-indigo-100 hover:border-indigo-300 rounded px-10',
											scheduleAgain === null || !scheduleAgain
												? ''
												: 'border-indigo-300'
										)}
									>
										Yes
									</div>
									<div
										onClick={() => setScheduleAgain(false)}
										className={classNames(
											'p-4 m-2 cursor-pointer border border-indigo-100 hover:border-indigo-300 rounded px-10',
											scheduleAgain === null || scheduleAgain
												? ''
												: 'border-indigo-300'
										)}
									>
										No
									</div>
								</div>
							</Banner>
						</div>

						{scheduleAgain && (
							<div className="mb-3">
								<TemplateDate
									name="Schedule again on"
									onChange={(index, scheduleAgainOn) =>
										setUpdateForm({ ...updatedForm, scheduleAgainOn })
									}
									value={currentForm?.scheduleAgainOn}
									minDate={moment().toDate()}
								/>
							</div>
						)}
					</div>
				) : null}

				{/*options?.defaultForm?.generateNext ? (
					<TemplateBoolean
						description="Auto generate next event"
						value={currentForm?.generateNext}
						onChange={(index, generateNext) =>
							setUpdateForm({ ...updatedForm, generateNext })
						}
					/>
					) : null*/}
			</div>
			<div className="flex justify-end mt-3 items-center">
				{scheduleAgain ||
				(options?.eventId &&
					options?.service?.occurrences &&
					options?.service?.occurrences !== 'none') ? null : (
					<TemplateBoolean
						name="Keep task open?"
						className={'mr-2'}
						onChange={(index, keepTaskOpen) =>
							setUpdateForm({ ...updatedForm, keepTaskOpen })
						}
						value={updatedForm?.keepTaskOpen}
					/>
				)}

				<Button
					onClick={() => {
						const taskObject = {
							id: options?.service?.id,
							completed: updatedForm?.completedDate || new Date(),

							...(updatedForm?.keepTaskOpen
								? {
										keepTaskOpen: updatedForm?.keepTaskOpen,
								  }
								: {}),

							...(scheduleAgain
								? {
										scheduleAgainOn: updatedForm?.scheduleAgainOn || new Date(),
								  }
								: {}),

							...(options?.eventId ? { eventId: options?.eventId } : {}),
						};

						console.log('taskObject: ', taskObject);

						onCompleteTask(
							{
								id: options?.service?.id,
								...(documentUploadForm?.length
									? {
											files: documentUploadForm,
											bucket: 'local-tasks',
											information: taskObject,
									  }
									: taskObject),
							},
							(response) => {
								handleClose();
							}
						);
					}}
				>
					{completingTask === 'pending'
						? 'Completing task...'
						: 'Complete Task'}
				</Button>

				{/*options?.eventId &&
				options?.service?.occurrences &&
				options?.service?.occurrences !== 'none' ? (
					<Button
						onClick={() => {
							onCompleteTask(
								{
									id: options?.service?.id,
									completed: updatedForm?.completedDate || new Date(),
									keepTaskOpen: true,
									...(scheduleAgain
										? {
												scheduleAgainOn:
													updatedForm?.scheduleAgainOn || new Date(),
										  }
										: {}),
									...(options?.eventId ? { eventId: options?.eventId } : {}),
								},
								(response) => {
									handleClose();
								}
							);
						}}
					>
						Complete Task
					</Button>
				) : (
					<>
						{!scheduleAgain && (
							<Button
								onClick={() => {
									onCompleteTask(
										{
											id: options?.service?.id,
											completed: updatedForm?.completedDate || new Date(),
											...(scheduleAgain
												? {
														scheduleAgainOn:
															updatedForm?.scheduleAgainOn || new Date(),
												  }
												: {}),

											...(options?.eventId
												? { eventId: options?.eventId }
												: {}),

											...(keepTaskOpen
												? {
														keepTaskOpen: updatedForm?.keepTaskOpen,
												  }
												: {}),
										},
										(response) => {
											onCloseModal();

											if (typeof options?.onClose === 'function') {
												options?.onClose(response);
											}

											setScheduleAgain(null);
											setForm({});
											setUpdateForm({});
										}
									);
								}}
							>
								Complete Task
							</Button>
						)}
					</>
				)*/}
			</div>
		</Modal>
	);
};
